export const STORAGE_KEY_PREFIX = 'string-sms-admin-';
export const VERSION = process.env.VUE_APP_VERSION;
export const STORAGE_KEY_LOGIN_ROLE = STORAGE_KEY_PREFIX + "role"
export const STORAGE_KEY_LOGIN_USER_NAME = STORAGE_KEY_PREFIX + "name"
export const STORAGE_KEY_LOGIN_TZ = STORAGE_KEY_PREFIX + "tz"
export const STORAGE_KEY_TOGGLE_SIDEBAR = STORAGE_KEY_PREFIX + "toggle-sidebar"

export const API_STATUS_CODE = {SUCCESS: 200};
export const SP_APP_STATUS = {RUNNING: 1, PAUSED: 2};
export const APP_STATUS = {CREATED: 0, LIVING: 1, PAUSED: 2, REJECTED: 3};
export const TPL_STATUS = {CREATED: 0, REVIEW: 1, LIVING: 2, REJECTED: 3};
export const ADMIN_ROLE = {DEBUG: 100, ADMIN: 9, SP_RW: 8, SP_RO: 7, CP_RW: 4, NONE: 0};
export const NODE_STATUS = {ONLINE: 1, OFFLINE: 2};
export const CTS = [
    {label: 'Ethiopia', value: 'et', code: '251'},
    {label: 'Thailand', value: 'th', code: '66'},
];
export const CURRENCIES = {1: 'USD'};
export const MAX_UPLOAD_SIZE = 1024 * 1024;

export const STATIC_FILE = {
    DEMO_IMPORT_LINK: 'https://d27qgmf6nmab3v.cloudfront.net/api/address/import_contract_demo.csv',
};

export const DLR_SUCCESS = 2;

export const DLR_STATUS = {
    100: 'ALL',
    0: 'unknown',
    1: 'en_route',
    2: 'delivered',
    3: 'expired',
    4: 'deleted',
    5: 'undeliverable',
    6: 'accepted',
    7: 'invalid',
    8: 'rejected',
};